import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import style from "./Subscription.module.css";
import tick from "../../assests/tick.png";
import { baseurl } from "../Url";
import { useState, useEffect } from "react";
import { Alert, Snackbar } from "@mui/material";


function Subscription() {
  const navigate = useNavigate();
  const location = useLocation();
  const UserID = location.state?.userID || localStorage.getItem("USERID");
  const UserName = location.state?.Username;
  const trialCount = location.state?.count;
  const is_Renewal = location.state?.renewal;
  const coins = location.state?.coins;
  const lastPath = location.state?.previousPath;
  const token = JSON.parse(localStorage.getItem("access-token"));

  const [agreed, setAgreed] = useState(false);
  const [renewClicked, setRenewClicked] = useState(is_Renewal);
  const [countryDetails, setCountryDetails] = useState("");

  const [totalPoints,setTotalPoints]=useState(0)
  const [discountApplied, setDiscountApplied] = useState(false);
  const [openSnackbar,setOpenSnackbar]=useState(false);
  const [isUsed,setIsUsed]=useState(false);
  const [discountAmountGBP,setDiscountAmountGBP]=useState(0);
  const [discountAmountINR,setDiscountAmountINR]=useState(0);


  const apiKey = import.meta.env.VITE_COUNTRY_API_KEY;
  const productID_INR = import.meta.env.VITE_PRODUCT_ID_INR;
  const productID_GBP = import.meta.env.VITE_PRODUCT_ID_GBP;

  const handleCheckboxChange = (event) => {
    setAgreed(event.target.checked);
  };

  async function createStripeOrder() {
    
    const requestData = {
      user_id: UserID,
      product: countryDetails === "India" ? productID_INR:productID_GBP,
      // currency: countryDetails === "India" ? "INR" : "GBP",
      currency: "INR",
      country: countryDetails,
      success_url: `${window.location.origin}/subscribe/success/?session_id={CHECKOUT_SESSION_ID}`,
      cancel_url: `${window.location.origin}/subscribe/failed/?session_id={CHECKOUT_SESSION_ID}`,
      amount:  renewClicked ? 699 : 799,
      product_name: "GrammarLocker",
      // This is the user's redemption choice only. The backend independently
      // checks eligibility and computes the discount from trusted records.
      use_points_discount: discountApplied,
    };
    await fetch(`${baseurl}/create/subscription/checkout-session`, {
      method: "POST",
      body: JSON.stringify(requestData),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === true) {
          window.location.assign(`${data.data[0].url}`);
        }
      });
  }

  async function trialUser() {
    const requestData = {
      user_id: UserID,
    };
    await fetch(`${baseurl}/user/trail`, {
      method: "POST",
      body: JSON.stringify(requestData),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === false && data.description === "Trail count exceded") {
          setOpenSnackbar(true)
        return; // stop further execution
      }
        if (data.status === true) {
          navigate("/start");
          localStorage.setItem("trialUser", true);
          localStorage.setItem(
            "access-token",
            JSON.stringify(data.data[0]?.access_token)
          );
          localStorage.setItem("ClubID", data.data[0]?.club_id);
          localStorage.setItem("ORGID", data.data[0]?.org_id);
          localStorage.setItem("USERID", data.data[0]?.user_id);
          localStorage.setItem("mentor", data.data[0]?.is_mentor);
          localStorage.setItem("username", data.data[0]?.username);
          localStorage.setItem("firstName", data.data[0]?.first_name);
        }
      });
  }

  async function getCountry() {
    await fetch(`https://pro.ip-api.com/json/?key=${apiKey}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setCountryDetails(data.country);
      });
  }

useEffect(() => {
  if (!UserID || UserID === "undefined") {
    console.log("No valid UserID, skipping fetchRewards");
    return;
  }
  const fetchRewards = async () => {
    try {
      const res = await fetch(`${baseurl}/points/apply/discount`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(
          { 
            user_id: UserID,
            is_inr: countryDetails === "India",
            is_pound: countryDetails !== "India"}
        ),
      });
      const data = await res.json();
      console.log("Fetched rewards:", data);
      if (data.status === true) {
        setTotalPoints(data.data.points_by_admin);
        setDiscountAmountINR(data.data.discount_amount_inr);
        setDiscountAmountGBP(data.data.deduction_amnt_gbp);
      }
    } catch (err) {
      console.error("Error fetching rewards:", err);
    }
  };
  fetchRewards();
  const interval = setInterval(fetchRewards, 10000);
  return () => clearInterval(interval);
}, [UserID]);



  useEffect(() => {
    getCountry();
  }, [location.state]);

  useEffect(() => {
    if (UserID === null || UserID === undefined) {
      navigate("/login");
    }
  }, []);

  useEffect(() => {
    if (lastPath === "Summary") {
      window.history.pushState(null, document.title, window.location.href);
      const handlePopState = () => {
        window.history.pushState(null, document.title, window.location.href);
      };
      window.addEventListener("popstate", handlePopState);
      return () => {
        window.removeEventListener("popstate", handlePopState);
      };
    }
  }, [lastPath]);

    const balanceAmountINR=799-discountAmountINR
    const balanceAmountGBP=9.99-discountAmountGBP
  return (
    <>
    <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          open={openSnackbar}
          sx={{ width: "25rem" }}
          autoHideDuration={3000}
          onClose={() => {
            setOpenSnackbar(false);
          }}
        >
          <Alert
            severity="warning"
            variant="filled"
            sx={{ width: "100%", fontSize: "1rem" }}
          >
            You are using Trial Account
          </Alert>
        </Snackbar>
    <div className={style.Container}>
      <div className={style.mainBody}>
        <div className={style.user}>
          <p>
            {" "}
            Almost there, <span>{UserName}!</span>{" "}
          </p>
        </div>
        {/* 
        <div className={style.course}>
          <p> Courses Available : </p>
        </div> */}

        <div className={style.cardContainer}>
          <div className={style.courseCard}>
            <div className={style.CardHeader}>
              <div className={style.package}>
                <p>
                  01 <span>GrammarLocker</span>
                </p>
              </div>
              <div className={style.slogan}>
                <p>
                  The ultimate online, interactive English grammar workbook.
                </p>
              </div>
            </div>

            <div className={style.CardBody}>
              {/* <div className={style.pointsHeader}> <p> What’s Included? </p></div> */}

              <div className={style.points}>
                <img src={tick} alt="tick" />
                <p>
                  <span>Unlimited access</span> to English grammar lessons
                </p>
              </div>
              <div className={style.points}>
                <img src={tick} alt="tick" />
                <p>
                  10,000+ <span>online, interactive exercises</span>{" "}
                </p>
              </div>

              <div className={style.points}>
                <img src={tick} alt="tick" />
                <p>
                  <span>Daily drills </span>and <span>weekly workouts</span> to
                  test your knowledge and understanding
                </p>
              </div>
              <div className={style.points}>
                <img src={tick} alt="tick" />
                <p>
                  <span>Personal online dashboard</span> to monitor your
                  progress
                </p>
              </div>
            </div>
          </div>

          <div className={style.subscribeCard}>
            <div className={style.subscribeCardBox}>
              <div className={style.subscribeCardHead}>
                <div className={style.summary}>
                  <p className={style.summaryTitle}>Order:</p>
                  <p className={style.summarySpan}>
                    Full, 24/7 access to GrammarLocker for one year
                  </p>
                </div>

                <div className={style.amount}>
                  <p className={style.amountTitle}>Sub Total:</p>
                  {countryDetails === "India" ? (
                    <p className={style.amountSpan}>
                      {" "}
                      INR <span>799</span>
                    </p>
                  ) : (
                    <p className={style.amountSpan}>
                      {" "}
                      £ <span>9.99 </span>
                    </p>
                  )}
                </div>
              </div>
              {/* {is_Renewal&&coins>="2500"?
              <div className={style.discountSection}>
                <button disabled={renewClicked} onClick={()=>setRenewClicked(true)} style={{background:renewClicked?"#03CD09":"",color:renewClicked?"#ffffff":""}}>You have <span style={{color:renewClicked?"#ffffff":""}}>2500 xp. Use Now</span></button>
                <div className={style.discountAmount}>
               <div className={style.discountAmountContainer}>
                  <div className={style.discountAmountLeft}><p>Discount</p></div>
                  <div className={style.discountAmountRight}><p>₹ {renewClicked?"100":"0"}</p></div>
               </div>
               <div className={style.discountAmountContainer}>
                <div className={style.discountAmountLeft}><h4>Total</h4></div>
                <div className={style.discountAmountRight}><p>₹ {renewClicked?"599":"699"}</p></div>
                </div>
                </div>
               
              </div>
              :""} */}

              <div className={style.adminCoin}>
                <button
                onClick={() => setDiscountApplied((prev) => !prev)}
                style={{
                  backgroundColor: discountApplied ? "#03CD09" : "",
                  color: discountApplied ? "#ffffff" : "#03CD09",
                  transition: "all 0.3s ease",
                }}
                >
                 <span style={discountApplied ? {color:"#ffffff"} : { color: "black" }}>You have</span>{" "}{totalPoints} xp. {discountApplied ? "Applied!" : "Use Now"}
                </button>
              </div>
                 <div className={style.discountAmount}>
               <div className={style.discountAmountContainer}>
                  <div className={style.discountAmountLeft}><p>Discount</p></div>
                  <div className={style.discountAmountRight}><p>{countryDetails === "India" ? "₹ " : "£ "}{discountApplied ? countryDetails === "India" ? discountAmountINR : discountAmountGBP  : 0}</p></div>
               </div>
               <div className={style.discountAmountContainer}>
                <div className={style.discountAmountLeft}><h4>Total</h4></div>
                <div className={style.discountAmountRight}><p>{countryDetails === "India" ? "₹ " : "£ "}
                {discountApplied ? countryDetails === "India"   ? balanceAmountINR   : balanceAmountGBP: countryDetails === "India"? 799: 9.99}</p></div>
                </div>
              </div>   
              <div className={style.declare}>
                <label>
                  <input
                    onChange={handleCheckboxChange}
                    type="checkbox"
                    name="remember"
                  />{" "}
                  &nbsp;
                  <p>
                    I accept all the{" "}
                    <a
                      href="https://englishwagon.com/terms-conditions/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      terms and conditions
                    </a>
                  </p>
                </label>
              </div>

              <div className={style.SubscriptionBtn}>
                <button
                  style={{
                    backgroundColor: !agreed ? "#898890" : "",
                    opacity: !agreed ? "0.75" : "",
                  }}
                  disabled={!agreed}
                  onClick={() => createStripeOrder()}
                >
                  Subscribe Now{" "}
                </button>
              </div>

              <div className={style.separator}>
                <span>OR</span>
              </div>

              <div className={style.startTrail}>
                <p>
                  {" "}
                  Unlock your potential with a free trial of GrammarLocker{" "}
                </p>

                <button
                  style={{
                    backgroundColor:
                      !agreed || trialCount >= 1 || trialCount >= "1"
                        ? "#898890"
                        : "",
                    opacity:
                      !agreed || trialCount >= 1 || trialCount >= "1"
                        ? "0.75"
                        : "",
                  }}
                  disabled={!agreed || trialCount >= 1 || trialCount >= "1"}
                  onClick={() => trialUser()}
                >
                  Start Trial{" "}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
}

export default Subscription;
